import { bgColorOptions } from '../../../../helpers/enums/themes/bgColorOptions.js';
import { fontColorOptions } from '../../../../helpers/enums/themes/fontColorOptions.js';

const confirmButtonConfig = {
  bgColor: bgColorOptions.blue,
  fontColor: fontColorOptions.white
};
const deleteButtonConfig = {
  bgColor: bgColorOptions.red,
  fontColor: fontColorOptions.white
};
const cancelButtonConfig = {
  bgColor: bgColorOptions['border-gray'],
  fontColor: fontColorOptions.shuttlegray
};

export { cancelButtonConfig, confirmButtonConfig, deleteButtonConfig };
//# sourceMappingURL=config.js.map
